module.exports = __webpack_public_path__ + "img/undraw_personal_settings_kihd.8d9502e6.png";